
<template>
  <div class="zmdet_i">
    <div class="detlist">
      <div class="detitem" v-for="(item, index) in det" :key="index">
        <div class="bt1">{{ item.title }}</div>
        <div class="lawdet">
          {{ item.cont | addviewall }}
          <span v-if="item.cont" @click="tojump(item)">阅读全文></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      det: [
        {
          title: "概念",
          cont: "",
          path: "/jpcol/zuimindetail/det_t",
          id: 1,
        },
        {
          title: "构成要素",
          cont: "",
          path: "/jpcol/zuimindetail/det_t",
          id: 2,
        },
        {
          title: "认定",
          cont: "",
          path: "/jpcol/zuimindetail/det_t",
          id: 3,
        },
        {
          title: "量刑标准",
          cont: "",
          path: "/jpcol/zuimindetail/det_t",
          id: 4,
        },
        {
          title: "立案标准",
          cont: "",
          path: "/jpcol/zuimindetail/det_t",
          id: 5,
        },
        {
          title: "司法解释",
          cont: "",
          path: "/jpcol/zuimindetail/det_t",
          id: 6,
        },
        {
          title: "法律意见",
          cont: "",
          path: "/jpcol/zuimindetail/det_t",
          id: 7,
        },
        // {
        //   title: "案例",
        //   path: "/jpcol/zuimindetail/det_t",
        //   id: 8,
        // },
      ],
      artid: this.$route.query.artid,
      artph: this.$route.query.ph,
    };
  },
  beforeMount() {
    console.log('beforeMount');
    this.getzmart();
  },
  methods: {
    tojump(item) {
      console.log("点击了跳转", item);
      this.$router.push({
        path: item.path,
        query: {
          artid: this.artid,
          ph: item.id,
        },
      });
    },
    getzmart() {
      let data = {
        id: this.artid,
        tab: this.artph,
      };
      this.$http.jpcol
        .getzuimincontent(data)
        .then((res) => {
          let det = this.det;
          let rsdata = res.data;
          console.log("rsdata", rsdata);
          det[0].cont = rsdata.gain;
          det[1].cont = rsdata.goucyj;
          det[2].cont = rsdata.rend;
          det[3].cont = rsdata.liangxbz;
          det[4].cont = rsdata.liabz;
          det[5].cont = rsdata.sifjs;
          det[6].cont = rsdata.falyj;
        })
        .catch((err) => {});
    },
  },
  filters: {
    addviewall(val) {
      if (!val) return "暂未收录相关数据！";
      else {
        return val.slice(0, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.zmdet_i {
  padding: 0 30px;
  .detlist {
    .detitem {
      padding: 26px 0 20px;
      border-bottom: 1px solid #eee;
      .bt1 {
        font-size: 20px;
        color: #333333;
        line-height: 20px;
      }
      .lawdet {
        margin-top: 22px;
        font-size: 14px;
        color: #999999;
        line-height: 26px;
        span {
          color: #0465ea;
          cursor: pointer;
        }
      }
    }
  }
}
</style>